import keyMirror from 'keymirror';

const ProfileTabNames = keyMirror({
  booking: null,
  guest: null,
  timeline: null,
  receipt: null,
  check: null,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default ProfileTabNames as any;
